import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { fromOthersNodeName } from "motw_core/Repositories/WorkflowRepository";
import * as React from "react";
import { BookOfMind } from "source/app/presentation/MainPanel/Workflows/BookOfMind/BookOfMind";
import { WorkflowsScrollIcon } from "source/app/presentation/MainPanel/Workflows/RootNodeName/WorkflowsFloatingTools/WorkflowsScrollIcon/WorkflowsScrollIcon";
import { WorkflowNodeActionsTool } from "./WorkflowNodeActionsTool/WorkflowNodeActionsTool";
import * as actionToolStyles from "./WorkflowNodeActionsTool/WorkflowNodeActionsTool.css";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { Sounds } from "source/app/services/Sound/Sounds";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import UI from "source/app/services/UI/UI";
import { GetRandomNodeAsync } from "source/app/services/Workflows/GetRandomNode";
import IconWithText from "../../../../../services/Shared/IconWithText/IconWithText";
import { IFloatingTool } from "../../../../Shared/FloatingTools/FloatingTools";
import { IWorkflowsState } from "../../IWorkflowsState";
import { randomNodeTarget } from "../../RenderChildNodes/ChildNodeName/ChildNodeName";

export interface IWorkflowsFloatingToolInputs {
    rootNode: IWorkflowNode;
    canReadInBookOfMind: boolean;
    hasWorkflowNodes: boolean;
    selectedNodeCount: number;
    isMultiSelectMode: boolean;
}

export const workflowsFloatingTools: IFloatingTool<IWorkflowsFloatingToolInputs>[] =
    [
        {
            name: `workflowsScrollToTop`,
            toRender: (inputs) => (
                <WorkflowsScrollIcon
                    direction="up"
                    disabled={!inputs.hasWorkflowNodes}
                />
            ),
            iconColor: `#4bc5ed`,
            tooltip: `Scroll to first workflow node`,
            isDisabled: (inputs) => !inputs.hasWorkflowNodes,
        },
        {
            name: `workflowsScrollToBottom`,
            toRender: (inputs) => (
                <WorkflowsScrollIcon
                    direction="down"
                    disabled={!inputs.hasWorkflowNodes}
                />
            ),
            iconColor: `#4bc5ed`,
            tooltip: `Scroll to last workflow node`,
            isDisabled: (inputs) => !inputs.hasWorkflowNodes,
        },
        {
            name: `workflowsBookOfMind`,
            toRender: () => (
                <IconWithText
                    iconSuffix={EGlyphicon.book}
                    whenClicked={() => BookOfMind(fromOthersNodeName)}
                    displayAsBlock={false}
                />
            ),
            iconColor: `#f682ff`,
            tooltip: `The Book of Mind`,
        },
        {
            name: `workflowsReadInBookOfMind`,
            toRender: (inputs) => (
                <IconWithText
                    iconSuffix={EGlyphicon["eye-open"]}
                    whenClicked={() => BookOfMind(inputs.rootNode.name)}
                    displayAsBlock={false}
                />
            ),
            iconColor: `#acacac`,
            tooltip: `Read`,
            isVisible: (inputs) => inputs.canReadInBookOfMind,
        },
        {
            name: `workflowNodeActions`,
            toRender: (inputs) => (
                <WorkflowNodeActionsTool
                    rootNode={inputs.rootNode}
                    selectedNodeCount={inputs.selectedNodeCount}
                    isMultiSelectMode={inputs.isMultiSelectMode}
                />
            ),
            iconColor: `#acacac`,
            tooltip: ``,
            withClass: actionToolStyles.allowsSubmenu,
        },
        {
            name: `workflowsRandom`,
            toRender: (inputs) =>
                inputs.rootNode.viewchronological ? (
                    <span />
                ) : (
                    <IconWithText
                        iconSuffix={EGlyphicon["random"]}
                        whenClicked={async () =>
                            await ActivateRandomNode(inputs.rootNode)
                        }
                        displayAsBlock={false}
                    />
            ),
            iconColor: `greenyellow`,
            tooltip: `Select random workflow node`,
        },
    ];

export async function ActivateRandomNode(rootNode: IWorkflowNode) {
    const randomNode = await GetRandomNodeAsync(rootNode);
    const topOffset = -0.6 * (window.outerHeight / 2);

    State.ReadClass<IWorkflowsState>(ESharedComponent.Workflows).setState(
        {
            randomNode,
        },
        () => {
            UI.ScrollToDiv(`#${randomNodeTarget}`, topOffset);
            Sounds.snapsMultiple.Play({ allowConcurrent: true });
        }
    );
}
